import React from 'react';

import {
  Group,
} from '@vkontakte/vkui';
import { AnimatePresence, motion } from 'framer-motion';

import about from './../../../../../images/mobile/about.png';
import styles from './MobileAboutUsPage.module.css';
import { MobileIntroContentPropsType } from './types';
import { HorizontalSlides } from '../../../../../components/HorizontalSlides';


export const MobileAboutUs: React.FC<MobileIntroContentPropsType> = ({ pagesOptions }) => {
  return (
    <div>
      <Group className={styles.container}>
        <AnimatePresence>
          <motion.div animate={{ scale: [1, 1.02, 1] }} transition={{ duration: 0.3 }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img className={styles.img} src={about} alt=''/>
          </motion.div>
        </AnimatePresence> 
        <HorizontalSlides pagesOptions={pagesOptions}/>
      </Group>
    </div>
  );
};
